/**
 * useIsSuperAdmin — Fix Round v7 (2026-07-12).
 *
 * Reads the `is_super_admin` claim from the JWT stored in localStorage.
 * Falls closed (returns false) on any decode failure. Used to gate
 * <DrawingCard>'s on-card url/status/hadToken diagnostic overlay: the
 * diagnostic is how we debug failures from screenshots, and it must
 * never leak to non-super-admins.
 *
 * Same decode pattern already inlined in DrawingControlPage.js:617;
 * this hook centralises it so all <DrawingCard> call sites pass the
 * same value.
 */
export function useIsSuperAdmin() {
  try {
    const tok = localStorage.getItem('accessToken') || localStorage.getItem('token') || '';
    const mid = tok.split('.')[1];
    if (!mid) return false;
    const pad = '='.repeat((4 - (mid.length % 4)) % 4);
    const b64 = (mid + pad).replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(b64));
    return !!payload.is_super_admin;
  } catch {
    return false;
  }
}
